import { render } from "./moduleSelector.vue?vue&type=template&id=74559cf6&ts=true"
import script from "./moduleSelector.vue?vue&type=script&lang=ts"
export * from "./moduleSelector.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__